export default __webpack_public_path__ + "static/media/blibli-illustration-transparent.b62f1913.png";